import React, {useEffect, useState} from 'react'
import {Form, Input, Button, Col, Row, Select} from 'antd'
import apiRequest from '../../hooks/ApiRequest'
import {toast} from 'react-toastify'

const {Option} = Select

const BrokerForm = props => {
  const {form, MasterBrokerID, BrokerID, recordID, onSuccess, modalVisible} =
    props
  const {getFieldDecorator} = form

  const [loading, setLoading] = useState(false)
  const [brokerList, setBrokerList] = useState([])
  const [formattedBrokerList, setformattedBrokerList] = useState([])
  const [masterBrokerList, setMasterBrokerList] = useState([])
  const [recordId, setRecordId] = useState(0)

  useEffect(() => {
    fetchMasterBrokers()
    fetchRelatedBrokers()

    if (BrokerID && MasterBrokerID) {
      form.setFieldsValue({
        masterBrokerId: MasterBrokerID,
        brokerId: BrokerID,
      })
      setRecordId(recordID)
    } else if (BrokerID) {
      form.setFieldsValue({brokerId: BrokerID})
    } else {
      form.resetFields()
    }
  }, [BrokerID, modalVisible, MasterBrokerID])

  const fetchMasterBrokers = async () => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/UsersForDropdown/broker-financeuser`,
        'GET',
      )
       const formattedData = (res?.data || []).map(user => ({
        ...user,
        name: `${user.name} (${user.roleName})`,
        value: user.id,
      }))
      debugger;
      setBrokerList(res?.data || [])
      setformattedBrokerList(formattedData || [])
    } catch (err) {
      console.error('Error fetching brokers:', err)
    }
  }

  const fetchRelatedBrokers = async () => {
    try {
      const loggedInUserId = localStorage.getItem('loggedInUserID')
      const roles = JSON.parse(localStorage.getItem('roles') || '[]')

      if (roles.includes('SuperAdmin')) {
        // SuperAdmin gets all master brokers
        const res = await apiRequest(
          `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/UsersForDropdown/masterbroker`,
          'GET',
        )
        console.log('res', res)

        setMasterBrokerList(res?.data || [])
      } else {
        const resU = await fetchRelations([loggedInUserId])
        const underwriterIds = resU.map(item => item.assigneeId)
        const resB = await fetchRelations(underwriterIds)
        const uniqueMap = new Map()
        resB.forEach(item => {
          if (!uniqueMap.has(item.assigneeId)) {
            uniqueMap.set(item.assigneeId, {
              id: item.assigneeId,
              name: item.assigneeName,
            })
          }
        })

        const formatted = Array.from(uniqueMap.values())
        setMasterBrokerList(formatted)
      }
    } catch (err) {
      console.error('Error fetching master brokers:', err)
    }
  }

  const fetchRelations = async payload => {
    const url = `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/GetUserRelationship`
    const res = await apiRequest(url, 'POST', payload)
    return res?.success ? res.data : []
  }

  const handleSubmit = e => {
    e.preventDefault()
    form.validateFields(async (err, values) => {
      if (err) return

      setLoading(true)
      debugger;
      try {
        const selectedMasterBroker = masterBrokerList.find(
          mb => mb.id === values.masterBrokerId,
        )
        const selectedBroker = brokerList.find(b => b.id === values.brokerId)

        if (!selectedMasterBroker || !selectedBroker) {
          toast.error('Invalid Broker or Master Broker selected')
          return
        }

        const payload = {
          AssignorId: selectedMasterBroker.id,
          AssignorName: selectedMasterBroker.name,
          childDto: [
            {
              AssigneeId: selectedBroker.id,
              AssigneeName: selectedBroker.name,
            },
          ],
          id: recordId,
        }

        const url = `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/AssignedSubordinates`
        const res = await apiRequest(url, 'POST', payload)

        if (res.success) {
          if (res.data?.success) {
            toast.success(recordId ? 'Broker Updated!' : 'Broker Assigned!')
            onSuccess()
          } else {
            toast.error(res.data.message || 'Something went wrong')
          }
        } else {
          const msg = res.error?.toLowerCase?.() || ''
          toast.error(res.error || 'Something went wrong')
        }
      } catch (err) {
        console.error('Submit error:', err)
        toast.error('Request failed, try again.')
      } finally {
        setLoading(false)
      }
    })
  }

  return (
    <div className="container mt-3">
      <div className="card p-4">
        <Form layout="vertical" onSubmit={handleSubmit}>
          <Row gutter={16}>
            <Col md={12}>
              <Form.Item label="Select Master Broker">
                {getFieldDecorator('masterBrokerId', {
                  rules: [
                    {required: true, message: 'Please select a Master Broker'},
                  ],
                })(
                  <Select placeholder="Select Master Broker">
                    {masterBrokerList.map(u => (
                      <Option key={u.id} value={u.id}>
                        {u.name}
                      </Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item label="Select Broker">
                {getFieldDecorator('brokerId', {
                  rules: [{required: true, message: 'Please select a Broker'}],
                })(
                  <Select placeholder="Select Broker">
                    {formattedBrokerList.map(u => (
                      <Option key={u.id} value={u.id}>
                        {u.name}
                      </Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="btn-success">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}

export default Form.create()(BrokerForm)
